import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import styles from "./BandeauFavoris.scss";
import MenuGauche from "src/app/menugauche/MenuGauche";
import ListeFavoris from "src/app/listefavori/ListeFavoris";
import { useAppState } from "src/app/state/StateProvider";

const BandeauFavoris = () => {

  const [{ configuration }] = useAppState();

  const [{ user, employeurs }] = useAppState();

  if (((user && user?.typePersonne === "Externe" && !user?.comptePersonnel) && (!employeurs || employeurs.length === 0))) {
    return <></>;
  }

  return (
    <AppRow className={styles.bandeauContainer}>
      <AppCol md="auto" className={styles.menuGaucheContainer}>
        <MenuGauche/>
      </AppCol>

      {(configuration.activeFavori) &&
        <AppCol className={styles.favorisContainer}>
          <ListeFavoris/>
        </AppCol>
      }

    </AppRow>
  );
};

export default BandeauFavoris;